import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { useNoteInsightsDateRange } from 'modules/Insights/Notes/hooks/useNoteInsightsDateRange';
import { NoteInsightsViewOptions } from 'modules/Insights/Notes/NoteInsightsContextProvider';
import { Period } from 'graphql/types';
import { InsightsViewOptionsSelector } from '../InsightsViewOptionsSelector';
import { InsightsDateRangeArrows } from '../InsightsDateRangePicker/InsightsDateRangeArrows';
import InsightDateRangeLabel from '../InsightsDateRangePicker/InsightDateRangeLabel';

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center'
  }
}));

type NavigatorWithoutPickerProps = {
  disablePrevious: boolean;
  setDisablePrevious: React.Dispatch<React.SetStateAction<boolean>>;
  disableNext: boolean;
  setDisableNext: React.Dispatch<React.SetStateAction<boolean>>;
  viewOptions: {
    value: NoteInsightsViewOptions;
    text: string;
  }[];
  currentPeriod: Period | null;
  setCurrentPeriod: (period: Period) => void;
  selectedViewOption: NoteInsightsViewOptions;
  setSelectedViewOption: (selectedViewOption: NoteInsightsViewOptions) => void;
};

const NavigatorWithoutPicker: React.FC<NavigatorWithoutPickerProps> = ({
  disablePrevious,
  setDisablePrevious,
  disableNext,
  setDisableNext,
  viewOptions,
  currentPeriod,
  setCurrentPeriod,
  selectedViewOption,
  setSelectedViewOption
}: NavigatorWithoutPickerProps) => {
  const classes = useStyles();
  const {
    timesheetPeriodString,
    updateNext,
    updatePrevious
  } = useNoteInsightsDateRange({
    currentPeriod,
    selectedViewOption,
    setCurrentPeriod,
    setSelectedViewOption,
    setDisablePrevious,
    disablePrevious,
    setDisableNext
  });

  return (
    <Grid
      container
      className={classes.root}
      data-testid="insights-navigator-component"
    >
      <InsightsDateRangeArrows
        disableNext={disableNext}
        disablePrevious={disablePrevious}
        updateNext={updateNext}
        updatePrevious={updatePrevious}
      />
      <InsightDateRangeLabel label={timesheetPeriodString} />
      <InsightsViewOptionsSelector
        setDisablePrevious={setDisablePrevious}
        setDisableNext={setDisableNext}
        disablePrevious={disablePrevious}
        viewOptions={viewOptions}
        currentPeriod={currentPeriod}
        setCurrentPeriod={setCurrentPeriod}
        setSelectedViewOption={setSelectedViewOption}
        selectedViewOption={selectedViewOption}
      />
    </Grid>
  );
};

export default React.memo(NavigatorWithoutPicker);
